const profile = {
    link_account: {
        anonymous: 'مجهول',
    },
    delete_account: {
        title: 'حذف الحساب',
        label: 'حذف الحساب',
        description: 'سيؤدي حذف حسابك إلى إزالة جميع المعلومات الشخصية وبيانات المستخدم والتكوين. لا يمكن التراجع عن هذا الإجراء.',
        button: 'حذف الحساب',
        p: {
            has_issue: 'نأسف لسماع أنك ترغب في حذف حسابك. قبل أن تتمكن من حذف حسابك ، يجب عليك حل المشكلات التالية.',
            after_resolved: 'بمجرد حل المشكلات ، يمكنك حذف حسابك. يرجى عدم التردد في الاتصال بنا إذا كنت بحاجة إلى أي مساعدة.',
            check_information: 'نأسف لسماع أنك ترغب في حذف حسابك. يرجى التحقق من المعلومات التالية بعناية قبل المتابعة.',
            remove_all_data: 'سيؤدي حذف حسابك إلى إزالة جميع البيانات المتعلقة بك في Logto Cloud. لذا يرجى التأكد من نسخ أي بيانات مهمة قبل المتابعة.',
            confirm_information: 'يرجى تأكيد أن المعلومات أعلاه هي ما تتوقعه. بمجرد حذف حسابك ، لن نتمكن من استعادته.',
            has_admin_role: 'نظرًا لأن لديك دور المسؤول في المستأجر التالي ، سيتم حذفه مع حسابك:',
            has_admin_role_other: 'نظرًا لأن لديك دور المسؤول في المستأجرات التالية ، سيتم حذفها مع حسابك:',
            quit_tenant: 'أنت على وشك الخروج من المستأجر التالي:',
            quit_tenant_other: 'أنت على وشك الخروج من المستأجرات التالية:',
        },
        issues: {
            console_sso: 'أزل جميع موصلات Console SSO التابعة لحسابك قبل حذف الحساب.',
            paid_plan: 'المستأجر التالي لديه خطة مدفوعة ، يرجى إلغاء الاشتراك أولاً:',
            paid_plan_other: 'المستأجرات التالية لديها خطط مدفوعة ، يرجى إلغاء الاشتراك أولاً:',
            subscription_status: 'المستأجر التالي لديه مشكلة في حالة الاشتراك:',
            subscription_status_other: 'المستأجرات التالية لديها مشكلات في حالة الاشتراك:',
            open_invoice: 'المستأجر التالي لديه فاتورة مفتوحة:',
            open_invoice_other: 'المستأجرات التالية لديها فواتير مفتوحة:',
        },
        error_occurred: 'حدث خطأ',
        error_occurred_description: 'عذرًا ، حدث خطأ ما أثناء حذف حسابك:',
        request_id: 'معرف الطلب: {{requestId}}',
        try_again_later: 'يرجى المحاولة مرة أخرى في وقت لاحق. إذا استمرت المشكلة ، يرجى الاتصال بفريق Logto مع معرف الطلب.',
        final_confirmation: 'تأكيد نهائي',
        about_to_start_deletion: 'أنت على وشك بدء عملية الحذف ولا يمكن التراجع عن هذا الإجراء.',
        permanently_delete: 'حذف بشكل دائم',
    },
    fields: {
        name: 'الاسم',
        name_description: 'الاسم الكامل للمستخدم بشكل قابل للعرض بما في ذلك جميع أجزاء الاسم (مثال: "جين دو").',
        avatar: 'الصورة الرمزية',
        avatar_description: 'رابط صورة الصورة الرمزية للمستخدم.',
        familyName: 'اسم العائلة',
        familyName_description: 'اسم العائلة للمستخدم (مثال: "دو").',
        givenName: 'الاسم الأول',
        givenName_description: 'الاسم الأول للمستخدم (مثال: "جين").',
        middleName: 'الاسم الأوسط',
        middleName_description: 'الاسم الأوسط للمستخدم (مثال: "ماري").',
        nickname: 'اللقب',
        nickname_description: 'اسم غير رسمي أو مألوف للمستخدم، قد يختلف عن اسمه القانوني.',
        preferredUsername: 'اسم المستخدم المفضل',
        preferredUsername_description: 'اسم مستخدم مختصر يرغب المستخدم في أن يُشار إليه به.',
        profile: 'الملف الشخصي',
        profile_description: 'رابط صفحة الملف الشخصي للمستخدم القابلة للقراءة (مثال: ملف وسائل التواصل الاجتماعي).',
        website: 'الموقع الإلكتروني',
        website_description: 'رابط الموقع الإلكتروني الشخصي أو المدونة للمستخدم.',
        gender: 'الجنس',
        gender_description: 'الجنس الذي يعرّف به المستخدم نفسه (مثال: "أنثى"، "ذكر"، "غير ثنائي").',
        birthdate: 'تاريخ الميلاد',
        birthdate_description: 'تاريخ ميلاد المستخدم بتنسيق محدد (مثال: "MM-dd-yyyy").',
        zoneinfo: 'المنطقة الزمنية',
        zoneinfo_description: 'المنطقة الزمنية للمستخدم بتنسيق IANA (مثال: "America/New_York" أو "Europe/Paris").',
        locale: 'اللغة',
        locale_description: 'لغة المستخدم بتنسيق IETF BCP 47 (مثال: "en-US" أو "ar-SA").',
        address: {
            formatted: 'العنوان',
            streetAddress: 'عنوان الشارع',
            locality: 'المدينة',
            region: 'الولاية',
            postalCode: 'الرمز البريدي',
            country: 'البلد',
        },
        address_description: 'العنوان الكامل للمستخدم بشكل قابل للعرض بما في ذلك جميع أجزاء العنوان (مثال: "123 الشارع الرئيسي، أني تاون، الولايات المتحدة 12345").',
        fullname: 'الاسم الكامل',
        fullname_description: 'مزيج مرن من اسم العائلة، الاسم الأول، والاسم الأوسط بناءً على التكوين.',
    },
};
export default Object.freeze(profile);
